module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('el-select', {
    staticClass: "gv-fototeca-voli",
    attrs: {
      "filterable": "",
      "remote": "",
      "size": "mini",
      "placeholder": "Seleziona un volo...",
      "id": "gv-fototeca-voli"
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.volo),
      callback: function($$v) {
        _vm.volo = $$v
      },
      expression: "volo"
    }
  }, _vm._l((_vm.voli), function(item) {
    return _vm._c('el-option', {
      key: item.id,
      staticClass: "gv-fototeca-voli-options",
      attrs: {
        "label": item.nome,
        "value": item.id
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49a48e71!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FototecaVoli.vue
// module id = 858
// module chunks = 39